<template>
  <div class="modal fade" data-backdrop="static" id="change-package-item" tabindex="-1" role="dialog" aria-labelledby="modal-block-vcenter" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="block block-themed block-transparent mb-0">
          <div class="block-header bg-info bg-danger">
            <h3 class="block-title"><i class="fa fa-sitemap"></i> Change Item</h3>
            <div class="block-options">
              <button type="button" class="btn-block-option" @click.prevent="clearData()" data-dismiss="modal" aria-label="Close">
              <i class="fa fa-fw fa-times"></i>
              </button>
            </div>
          </div>
          <transition name="slide-fade">
            <div class="text-center alert-message-top" v-if="errorMsg">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="alert-message alert-danger alert-error-message">{{errorMsg}}</div>
              </div>
            </div>
          </transition>
          <div class="block-content">
            <div class="form-group required">
              <label class="control-label">Label</label>
              <input type="text" v-model="label" name="label" v-validate="'required'" data-vv-as="Label" class="form-control form-control-alt" placeholder="Label">
              <p v-if="errors.has('label')" class="errorMsg">{{ errors.first('label') }}</p>
            </div>
            <div class="form-group required">
              <label class="control-label">Select item</label>
              <select id="package-change-item" placeholder="Select Item.." class="form-control package-select2-dropdown" style="width: 100%;">
                <option></option>
                <option v-for="(item, index) in library.items" :key="index" :bind:value="item.Name">{{ item.Name }}</option>
              </select>
              <p v-if="itemError" class="errorMsg">The Item field is required.</p>
            </div>
          </div>
          <div class="block-content block-content-full text-right border-top button-loader">
            <button type="button" class="btn btn-sm btn-light" data-dismiss="modal" @click.prevent="clearData()">Close</button>
            <button type="button" class="btn btn-sm btn-primary" @click="changeItem" :bind:disabled="showModalLoader">
              <div><i class="fa fa-save mr-1"></i><span>Save</span></div>
              <span class="modal-loader" v-if="showModalLoader">
                <hash-loader class="custom-class text-white" color="#fff" loading="loading" size="15" sizeUnit="px"></hash-loader>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import { mapActions, mapState } from 'vuex';
import { VueSpinners, HashLoader } from '@saeris/vue-spinners';
import { helper } from '@/helper.js';
import $ from 'jquery';
Vue.use(VeeValidate, VueSpinners);

export default {
  name: 'ChangeItem',
  data() {
    return {
      item: '',
      label: '',
      errorMsg: '',
      itemError: false,
      showModalLoader: false
    };
  },
  computed: {
    ...mapState({
      library: state => state.library
    })
  },
  mounted() {
    let vm = this;
    $('#package-change-item').on('change', function () { vm.item = $(this).val(); vm.itemError = false; } );
  },
  components: {
    HashLoader
  },
  methods: {
    ...mapActions('alert', ['success', 'error', 'clear']),
    changeItem() {
      let vm = this;
      this.$validator.validate().then(valid => {
        if (vm.validate() && valid) {
          vm.showModalLoader = true;
          vm.errorMsg = '';
          helper.sendPostRequest('/packages/change_item', {
            'Label' : vm.label,
            'Item' : vm.item
          }).then((data) => {
            if (data.status === 'success') {
              jQuery('#change-package-item').modal('hide');
              vm.$emit('showSuccessMsg', data.message);
              vm.showModalLoader = false;
              vm.clearData();
              vm.$emit('loadPackage', true);
            } else {
              vm.errorMsg = data.message;
              vm.showModalLoader = false;
            }
          });
        }
      });
    },
    setData(label) {
      this.label = label;
    },
    clearData() {
      this.item = '';
      this.label = '';
      this.errorMsg = '';
      this.itemError = false;
      $('.package-select2-dropdown').val(null).trigger('change');
      this.$validator.reset();
    },
    validate() {
      if (!this.item) {
        this.itemError = true;
        return false;
      }

      return true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// source/components/modals/ChangeItem.vue